export const warmPastels = [
  '#ffe5b4', '#ffd6e0', '#fff2b2', '#ffd1b3',
  '#ffe0b2', '#ffe4e1', '#fff0e1', '#ffe6cc',
];

export const pageGradient = "linear-gradient(120deg, #fff 0%, #f9f7fa 100%)";
export const containerBg = "rgba(255,255,255,0.85)";